import { z } from "zod";
import { ClientId, DateSchema } from "../../Types";
import { GoalBasedFinancialPlanIdSchema, GoalBasedFinancialPlanIncomeIdSchema, } from "../ids";
import { GoalBasedFinancialPlanAnnualIncreaseInputSchema, GoalBasedFinancialPlanAnnualIncreaseResponseSchema, GoalBasedFinancialPlanAssetLiabilityId, GoalBasedPlanDateRequest, GoalBasedPlanDateResponse, GoalBasedRepeatTimeFrameSchema, } from "../types";
export const GoalBasedIncomeTypeSchema = z.enum([
    "Salary",
    "SocialSecurity",
    "Pension",
    "Annuity",
    "Distributions",
    "Bonus",
    "ChildSupport",
    "Royalty",
    "Inheritance",
    "ReverseMortgage",
    "Loan",
    "OtherIncome",
]);
export const GoalBasedFinancialPlanIncomeResponseSchema = z.object({
    incomeId: GoalBasedFinancialPlanIncomeIdSchema,
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
    incomeType: GoalBasedIncomeTypeSchema,
    owner: ClientId,
    name: z.string(),
    amount: z.string(),
    annualIncrease: GoalBasedFinancialPlanAnnualIncreaseResponseSchema,
    depositAccount: GoalBasedFinancialPlanAssetLiabilityId.optional(),
    sourceAccount: GoalBasedFinancialPlanAssetLiabilityId.optional(),
    startDate: GoalBasedPlanDateResponse.optional(),
    endDate: GoalBasedPlanDateResponse.optional(),
    repeats: GoalBasedRepeatTimeFrameSchema,
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const GoalBasedFinancialPlanIncomePostRequestSchema = z.object({
    incomeType: GoalBasedIncomeTypeSchema,
    owner: z.string(),
    name: z.string(),
    amount: z.string(),
    annualIncrease: GoalBasedFinancialPlanAnnualIncreaseInputSchema,
    startDate: GoalBasedPlanDateRequest.nullish(),
    endDate: GoalBasedPlanDateRequest.nullish(),
    repeats: GoalBasedRepeatTimeFrameSchema,
    depositAccount: z.string().optional(),
    sourceAccount: z.string().optional(),
});
export const GoalBasedFinancialPlanIncomePatchRequestSchema = GoalBasedFinancialPlanIncomePostRequestSchema.partial();
export const GoalBasedFinancialPlanIncomeDeleteResponseSchema = z.object({
    message: z.string(),
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
});
//# sourceMappingURL=types.js.map